import { render, staticRenderFns } from "./KabTrailer.vue?vue&type=template&id=7934af98&"
import script from "./KabTrailer.vue?vue&type=script&lang=js&"
export * from "./KabTrailer.vue?vue&type=script&lang=js&"
import style0 from "./KabTrailer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports